import { ActiveUsersCountPayload } from 'app/interfaces/socket';
import React, { createContext, Dispatch, FC, SetStateAction, useCallback, useState } from 'react';

interface AppCountersProviderProps {
  activeMatchesCount: number;
  unreadNotificationsCount: number;
  activeTournamentsCount: number;
  pastTournamentsCount: number;
  participatedTournamentsCount: number;
  onlinePlayersCount: number;
  activeUsers: string[];
  setUnreadNotificationsCount: Dispatch<SetStateAction<number>>;
  setActiveMatchesCount: Dispatch<SetStateAction<number>>;
  setActiveTournamentsCount: Dispatch<SetStateAction<number>>;
  setPastTournamentsCount: Dispatch<SetStateAction<number>>;
  setParticipatedTournamentsCount: Dispatch<SetStateAction<number>>;
  setOnlinePlayers: (onlinePlayers: ActiveUsersCountPayload) => void;
}

export const AppCountersContext = createContext<AppCountersProviderProps>({
  activeMatchesCount: 0,
  unreadNotificationsCount: 0,
  activeTournamentsCount: 0,
  pastTournamentsCount: 0,
  onlinePlayersCount: 0,
  participatedTournamentsCount: 0,
  activeUsers: [],
  setUnreadNotificationsCount: () => null,
  setActiveMatchesCount: () => null,
  setActiveTournamentsCount: () => null,
  setPastTournamentsCount: () => null,
  setParticipatedTournamentsCount: () => null,
  setOnlinePlayers: () => null,
});

export const AppCountersProvider: FC<AppCountersProviderProps> = ({ children }) => {
  const [activeMatchesCount, setActiveMatchesCount] = useState<number>(0);
  const [activeTournamentsCount, setActiveTournamentsCount] = useState<number>(0);
  const [pastTournamentsCount, setPastTournamentsCount] = useState<number>(0);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0);
  const [participatedTournamentsCount, setParticipatedTournamentsCount] = useState<number>(0);
  const [onlinePlayersCount, setOnlinePlayersCount] = useState<number>(0);
  const [activeUsers, setActiveUsers] = useState<string[]>([]);

  const setOnlinePlayers = useCallback((onlinePlayers: ActiveUsersCountPayload) => {
    setOnlinePlayersCount(onlinePlayers.total);
    setActiveUsers(onlinePlayers.users);
  }, []);

  return (
    <AppCountersContext.Provider
      value={{
        activeMatchesCount,
        unreadNotificationsCount,
        activeTournamentsCount,
        pastTournamentsCount,
        participatedTournamentsCount,
        onlinePlayersCount,
        activeUsers,
        setUnreadNotificationsCount,
        setActiveMatchesCount,
        setActiveTournamentsCount,
        setPastTournamentsCount,
        setParticipatedTournamentsCount,
        setOnlinePlayers,
      }}
    >
      {children}
    </AppCountersContext.Provider>
  );
};
